import { GamOrderRetargetingDealsDeliveryDTO } from 'features/globalSetup/api/types/gamOrderRetargetingDealsDeliveryDTO'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'

export const GAM_ORDER_RETARGETING_DEALS_DELIVERY_FRAGMENT: TypedDocumentNode<GamOrderRetargetingDealsDeliveryDTO> = gql`
  fragment GamOrderRetargetingDealsDeliveryFragment on GamOrderRetargetingDealsDelivery {
    currency
    errorMessage
    geo
    proposalId
    status
  }
`
